import PropTypes from 'prop-types';
import { Control, DomUtil, DomEvent } from 'leaflet';
import MapControlBase from './MapControlBase';
import componentBase from '../../lib/component-base';

const expandFullscreenBkg = `url(${require('../../../static/images/flight-tracker/fullscreen-expand.png')})`;
const closeFullscreenBkg = `url(${require('../../../static/images/flight-tracker/fullscreen-close.png')})`;

@componentBase('FullScreenControl')
export default class FullScreenControl extends MapControlBase {
  static propTypes = {
    map: PropTypes.object,
    enterFullscreen: PropTypes.func,
    exitFullscreen: PropTypes.func,
  };

  componentDidMount() {
    const Ctrl = Control.extend({
      options: {
        position: 'topright',
      },

      reset: this.reset(),

      onAdd: (map) => {
        const mapResult = {
          ...map,
        };
        const container = DomUtil.create('div', 'leaflet-bar leaflet-control');
        container.style.display = (this.props.hide ? 'none' : null);

        const preloadActive = DomUtil.create('div', container);
        preloadActive.style.backgroundImage = closeFullscreenBkg;

        const preloadInactive = DomUtil.create('div', container);
        preloadInactive.style.backgroundImage = expandFullscreenBkg;

        const parent = DomUtil.create('div', 'leaflet-bar-part', container);
        parent.style.width = '50px';
        parent.style.height = '30px';
        parent.style.backgroundImage = preloadInactive.style.backgroundImage;
        parent.style.backgroundSize = '50px 30px';
        parent.style.backgroundRepeat = 'no-repeat';
        parent.style.cursor = 'pointer';

        const checkButton = () => {
          if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
            parent.style.backgroundImage = preloadActive.style.backgroundImage;
          } else {
            parent.style.backgroundImage = preloadInactive.style.backgroundImage;

            // 3 for giant screens, 2 for mobile and small desktop (international flights)
            if (mapResult._layersMinZoom === 3) {
              mapResult.options.minZoom = 2;
            }

            mapResult.centerTracker();
          }
        };

        document.addEventListener('fullscreenchange', () => checkButton());
        document.addEventListener('webkitfullscreenchange', () => checkButton());
        document.addEventListener('mozfullscreenchange', () => checkButton());
        document.addEventListener('msfullscreenchange', () => checkButton());

        DomEvent
          .on(container, 'dblclick', DomEvent.stopPropagation)
          .on(container, 'dblclick', DomEvent.preventDefault)
          .on(container, 'click', (e) => {
            DomEvent.stopPropagation(e);
            DomEvent.preventDefault(e);

            if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
              this.props.exitFullscreen();
              this.context.reportButtonPress('TrackerFullscreenExit', 0);
            } else {
              this.props.enterFullscreen();
              this.context.reportButtonPress('TrackerFullscreenEnter', 0);

              // 3 for giant screens, 2 for mobile and small desktop (international flights)
              if (mapResult._layersMinZoom < 3) {
                mapResult.options.minZoom = 3;
              }
            }
          });

        return container;
      },
    });

    this.control = new Ctrl();
    this.control.reset();
    this.props.map.addControl(this.control);
  }
}



// WEBPACK FOOTER //
// ./src/components/MapControlsAndLayers/FullScreenControl.js